module.exports = __webpack_public_path__ + "static/media/locked.c9a0bf2a.svg";